'use strict';

export default class SendResetPasswordController {
  email: string = '';

  submitted: boolean = false;
  emailSent: boolean = false;
  hasErrors: boolean = false;
  errorMessage: string = '';

  $http;
  $state;
  TranslationService;

  /*@ngInject*/
  constructor($http, $state, TranslationService) {
    this.$http = $http;
    this.$state = $state;
    this.TranslationService = TranslationService;
  }

  submit(form) {
    this.submitted = true;

    if (form.$invalid) {
      this.hasErrors = true;
      this.errorMessage = this.getErrorMessage(form);
      return false;
    }

    this.hasErrors = false;

    // Send link 
    this.$http.post("/api/resetPasswords/sendLink", {
      email: this.email,
      language: this.TranslationService.getCurrentLanguage()
    }).then(res => {
      if (res.status == 201) { 
        this.emailSent = true;
      }
    }).catch(err => {
      this.hasErrors = true;
      this.errorMessage = this.TranslationService.translate('reset_password_email_not_found');
    });
  }

  getErrorMessage(form) {
    if(form.email.$error.required) {
      return this.TranslationService.translate('reset_password_enter_email');
    }

    if(form.email.$error.email) {
      return this.TranslationService.translate('login_enter_valid_mail');
    }

    return this.TranslationService.translate('reset_password_email_not_found');
  }
}



// WEBPACK FOOTER //
// ./client/app/account/sendResetPassword/sendResetPassword.controller.ts